<template>
  <el-dialog
    class="dialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
    :show-close="false"
  >
    <!-- <p class="content">{{$t('remoteLogin',{time:time})}}</p> -->
    <p class="content">{{ $t("remoteLogin") }}</p>
    <span slot="footer" class="dialog-footer">
      <el-button class="button" type="primary" @click="sure">{{
        $t("sure")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import { mapMutations } from "vuex";
export default {
  // data() {
  //   return {
  //     dialogVisible: true,
  //   }
  // },

  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    time: {
      type: String,
      default: "",
    },
  },
  mounted() {},
  methods: {
    // ...mapMutations(['setRemoteLogin']),
    sure() {
      this.$emit("sure");
      // this.dialogVisible = false
      // this.setRemoteLogin(false)
    },
  },
};
</script>

<style lang='scss' scoped>
.dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0.625rem;
  width: auto;
}
.content {
  // margin-left: 0.125rem;
  // margin-right: 0.125rem;
  // margin-bottom: 0.0625rem;
  font-size: 0.1375rem;
  line-height: 0.25rem;
  // color: rgba($color: #0c121c, $alpha: 0.6);
  color: #2e2e2e;
  // font-size: 500;
  // margin-top: 0.06875rem;
  // min-width: 2.5rem;
  font-weight: bold;
  text-align: center;
}
.button {
  width: 0.9375rem;
  margin-bottom: 0.125rem;
  border-radius: 0.15rem;
}
/deep/ .el-dialog__footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/common/remoteLoginDialog.vue